// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"96451b4b","186":"6f2d11bd","223":"23fd1c98","225":"b21e1881","272":"e2e05ec8","372":"597e0f7e","573":"4188c9fa","738":"6a4000f0","841":"7c7a643d","856":"4236dfaa"}[chunkId] + ".chunk.js";
};